import React, { StrictMode, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from '../../App';
import Testing from '../../pages/testing/Testing';

const contentContainer = document.getElementById('test-process');

// Функция для монтирования тестового процесса в контейнере с id "test-process"
export function mountTestPage() {
    if (!contentContainer) return;

    const root = ReactDOM.createRoot(contentContainer);
    let clickKey = 0;
    const renderTest = (clickedBtn: string) => {
        clickKey += 1;
        // console.log('renderTest', clickedBtn)
        root.render(
            <StrictMode>
                <App>
                    <Testing key={clickKey} clickedBtn={clickedBtn} />
                </App>
            </StrictMode>
        );
    };

    (window as any).renderTest = renderTest;

    const divTsStarts = document.querySelectorAll('.js__ts-start');
    const classTsClear = '.js__ts-clear';
    const divTsContinues = document.querySelectorAll('.js__ts-continue');
    const divTsClearAndStarts = document.querySelectorAll('.js__ts-start-clear-test');
    const divTsLastAttempt = document.querySelectorAll('.js__ts-last-attempt');

    contentContainer?.addEventListener('click', (e) => {
        const targetElement = (e.target as HTMLElement).closest(classTsClear);
        if (targetElement) {
            renderTest('clear');
        }
    });

    divTsLastAttempt.forEach((divTsStart) => {
        divTsStart.addEventListener('click', () => {
            renderTest('lastAttempt');
        });
    });

    divTsStarts.forEach((divTsStart) => {
        divTsStart.addEventListener('click', () => {
            renderTest('start');
        });
    });

    divTsContinues.forEach((divTsContinue) => {
        divTsContinue.addEventListener('click', () => {
            renderTest('continue');
        });
    });

    divTsClearAndStarts.forEach((divTsClearAndStart) => {
        divTsClearAndStart.addEventListener('click', () => {
            renderTest('clearAndStart');

        });
    });
}


function mountAutoRouting() {
    if (!contentContainer) return;

    const root = ReactDOM.createRoot(contentContainer);
    root.render(
        <StrictMode>
            <App>
            </App>
        </StrictMode>
    );
}

if (contentContainer && contentContainer.dataset.testProcess === 'true') {
    mountTestPage();
} else {
    mountAutoRouting();
}